import { Grid, Typography } from '@mui/material';
import React from 'react';
import { Draggable, DraggableProvided } from 'react-beautiful-dnd';

import { FavouriteAccessPointData } from '../../api/types';
import { useTranslations } from '../Translations/TranslationsProvider';
import { FavouriteAccessPointWrapper } from './FavouriteAccessPoint';

interface FavouritesListProps {
    favourites: FavouriteAccessPointData[];
}

export const FavouritesList: React.FC<FavouritesListProps> = React.memo(({ favourites }) => {
    const { translations } = useTranslations();

    return favourites?.length > 0 ? (
        <Grid container spacing={2}>
            {favourites?.map((accessPoint: FavouriteAccessPointData, index: number) => (
                <Grid item xs={12} key={accessPoint.accessPointCode}>
                    <Draggable draggableId={accessPoint.accessPointCode} index={index}>
                        {(provided: DraggableProvided) => (
                            <FavouriteAccessPointWrapper
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                accessPoint={accessPoint}
                            />
                        )}
                    </Draggable>
                </Grid>
            ))}
        </Grid>
    ) : (
        <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2}>
            <Grid item xs={8} container direction="column" alignItems="center">
                <Typography variant="h5" color="textSecondary" style={{ textAlign: 'center' }}>
                    {translations.MY_FAVOURITES_EMPTY}
                </Typography>
            </Grid>
        </Grid>
    );
});
